const p={Base:"1px",Lg:"4px",Md:"2px",None:0,Xl:"8px"};export{p as BorderWidth};
